import { CONSTANTS } from "utils/constant";

export const AddOn={
    weight:CONSTANTS.KG,
    height:CONSTANTS.CM,    
}
export const AddBefore={
    alternate_mobile_number:"+91",
}